import styled from 'styled-components'

export const StyledImage = styled.div`
  ${({ theme: { media } }) => media.up.lg} {
    margin-bottom: 40px;
  }
`
